import { CommonKeyMapping } from 'models/platforms/commonKeyMappings';
import { OneTrustRemoteKeys } from 'types/oneTrust';

// These keys do not need to be registered - done by default
const MandatoryTizenKeyMapping = {
  37: 'Left',
  38: 'Up',
  39: 'Right',
  40: 'Down',
  13: 'Enter',
  10009: 'Back',
};

export const AdditionalTizenKeyMapping = {
  ...CommonKeyMapping,
  ...{ 10182: 'Exit' }, // In some cases for Truex, Tizen passes the remote input instead of internally handling it
} as const;

export const TizenKeyMapping: Record<number, string> = {
  ...MandatoryTizenKeyMapping,
  ...AdditionalTizenKeyMapping,
};

/**
 * Back keys handed to OneTrust. Chromium leaves `event.code` empty for the
 * vendor code 10009, so OneTrust falls through to the `keyCode`.
 */
export const TizenOneTrustKeyMapping: OneTrustRemoteKeys = {
  10009: 'BACK',
};
